import { FormField } from '../../../types/form-builder.types';
import { cn } from '@shondalai/ui-commons';
import { Check } from 'lucide-react';

interface ImageChoiceFieldProps {
  field: FormField;
  value: string | string[];
  onChange: (value: string | string[]) => void;
}

export function ImageChoiceField({ field, value, onChange }: ImageChoiceFieldProps) {
  const config = field.config;
  const options = (config as any).options || [];
  const isMultiple = (config as any).questionType === 'multiple' || (config as any).allowMultiple;
  const columns = (config as any).imageColumns || 3;
  const disabled = (config as any).disabled;

  const handleSelect = (optionValue: string) => {
    if (isMultiple) {
      const currentValues = Array.isArray(value) ? value : [];
      const newValues = currentValues.includes(optionValue)
        ? currentValues.filter(v => v !== optionValue)
        : [...currentValues, optionValue];
      onChange(newValues);
    } else {
      onChange(optionValue);
    }
  };

  const isSelected = (optionValue: string) => {
    if (isMultiple) {
      return Array.isArray(value) && value.includes(optionValue);
    }
    return value === optionValue;
  };

  return (
    <div className="easyforms-image-choice-field">
      <div
        className="grid gap-4"
        style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}
      >
        {options.map((option: any) => (
          <button
            key={option.value}
            type="button"
            onClick={() => !disabled && handleSelect(option.value)}
            disabled={disabled}
            className={cn(
              "relative group rounded-lg border-2 overflow-hidden transition-all",
              "hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2",
              isSelected(option.value)
                ? "border-primary bg-primary/5"
                : "border-border",
              disabled && "opacity-50 cursor-not-allowed"
            )}
          >
            {option.imageUrl && (
              <div className="aspect-square bg-muted">
                <img
                  src={option.imageUrl}
                  alt={option.label}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            <div className="p-3 text-center">
              <span className="text-sm font-medium">{option.label}</span>
            </div>
            {isSelected(option.value) && (
              <div className="absolute top-2 right-2 w-6 h-6 rounded-full bg-primary text-primary-foreground flex items-center justify-center">
                <Check className="h-4 w-4" />
              </div>
            )}
          </button>
        ))}
      </div>
      {config.helpText && (
        <p className="text-xs text-muted-foreground mt-2">{config.helpText}</p>
      )}
    </div>
  );
}

